import { create } from 'zustand'

const useDropdownStore = create((set) => ({
    open: false,
    menus: {},
    setOpen: (new_state, id = 'legacy') => set(state => {
        if (!!state.menus[id] === !!new_state) return state;
        const menus = { ...state.menus };
        if (new_state) menus[id] = true;
        else delete menus[id];
        return { menus, open: Object.keys(menus).length > 0 };
    }),
}))

export default useDropdownStore